export const getRandomInt = (min: number, max: number): number => {
  min = Math.ceil(min);
  max = Math.floor(max);

  return Math.floor(Math.random() * (max - min)) + min;
};

export const removeWordsFromLine = (line: string, percentage: number): Word[] => {
  var words = line.split(' ')
  var ans: Word[] = []

  ans = words.map((word: string, index: number) => {
    return {
      id: index,
      text: word,
      isEmpty: getRandomInt(0, 100) <= percentage,
    }
  });

  return ans;
}

export const removeWords = (lines: string[], percentage: number): Word[][] => {
  var words: Word[][] = [];

  lines.forEach(line => {
    words.push(removeWordsFromLine(line, percentage));
  });

  return words;
}